import React, {useEffect, useLayoutEffect, useState} from "react";
import LeftSloth from "../assets/sloth/cat.png";
import MiddleSloth from "../assets/sloth/snowboard.png";
import RightSloth from "../assets/sloth/explorer.png";
import { useInView } from "react-intersection-observer";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LeftLeaf from "../components/smsc/LeftLeaf";
import RightLeaf from "../components/smsc/RightLeaf";
import Nav from "../components/smsc/Nav";
function RoundedBottom(props) {
  return (
    <svg
      viewBox="0 0 1440 237"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0l158.331 62.5c377.543 149.029 794.114 167.356 1183.289 52.057L1440 85.409V237H0V0z"
        fill="currentColor"
      />
    </svg>
  );
}

function Vine(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-100.68 0 1573.1 303"
      preserveAspectRatio="none" 
      {...props}
    >
      <path
        d="M936.836 303c-22.677 0-45.396-.427-68.158-1.282-165.641-6.239-334.165-35.096-500.894-85.759C83.9 129.687-98.88 8.319-100.676 7.102L-95.933 0C-94.13 1.21 87.79 121.983 370.539 207.861c260.808 79.213 663.231 144.089 1099.261 3.321l2.62 8.119C1300.18 274.925 1120.31 303 936.836 303z"
        fill="#0D3727"
      />
    </svg>
  );
}




const Hero = () => {
  const maxMovement = 100;
  const maxMovementText = 15;

  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  const [introComplete, setIntroComplete] = useState(false);

  gsap.registerPlugin(ScrollTrigger);


  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.5,
    delay: 200,
    triggerOnce: true,
  });

  const mouseHandler = (e) => {
    const movementX = (e.movementX || e.mozMovementX || e.webkitMovementX || 0) * 5;
    if (introComplete){

    gsap.to(".sloth-1", {
      x: clamp(movementX, -maxMovement, maxMovement),
      duration: 0.5,
      ease: "power1.inOut",
    });

    gsap.to(".sloth-2", {
      x: clamp(movementX, -maxMovement, maxMovement) * -1,
      duration: 0.5,
      ease: "power1.inOut",
    });

    gsap.to(".sloth-3", {
      x: clamp(movementX, -maxMovement, maxMovement),
      duration: 0.5,
      ease: "power1.inOut",
    });


    gsap.to(".heading-top", {
      x: clamp(movementX, -maxMovementText, maxMovementText) * -1,
      duration: 0.5,
      ease: "power1.inOut",
    });


    
    gsap.to(".heading-bottom", {
      x: clamp(movementX, -maxMovementText, maxMovementText),
      duration: 0.5,
      ease: "power1.inOut",
    });


  }
    
  };

  const mouseLeaveHandler = () => {
    
    if (introComplete){
    

      
      gsap.to(".sloth", {
      x: 0,
      duration: 0.5,
      ease: "power1.inOut",
    });

          
    gsap.to(".heading", {
      x: 0,
      duration: 0.5,
      ease: "power1.inOut",
    });


  }
    
  };


  
  useEffect(() => {
    if (introComplete){
      gsap.to(".left-hero-leaf", {
        rotate: 200,
        duration: 5,
        scrollTrigger: {
          trigger: ref.current,
          scrub: true
        }
      });

      gsap.to(".right-hero-leaf", {
        rotate: 450,
        duration: 5,
        scrollTrigger: {
          trigger: ref.current,
          scrub: true
        }
      });

      gsap.to(".rounded-bottom", {
        scaleY: 3,
        duration: 5,
        transformOrigin: "bottom",
        scrollTrigger: {
          trigger: ref.current,
          scrub: true
        }
      });

      
      gsap.to(".vine", {
        y: -240,
        duration: 5,
        scrollTrigger: {
          trigger: ref.current,
          scrub: true
        }
      });

         
      gsap.to(".sloth", {
        scale: 0.75,
        duration: 5,
        scrollTrigger: {
          trigger: ref.current,
          scrub: true
        }
      });





  

    }
  } , [introComplete]);


  useLayoutEffect(() => {

      // rotate(344deg) scale(3.5) translateY(123px)

      const tl = gsap.timeline({onComplete: () => setIntroComplete(true)});

      tl.fromTo(".left-hero-leaf", {
        rotate: `308deg`,
        y: "232px",
        scale:3.5,
      }, {
        rotate: `350deg`,
        y: "0px",
        duration: 1.5,
        scale:1,
        ease: "power1.inOut",
      }, "1");

      tl.fromTo(".right-hero-leaf", {
        rotate: `397deg`,
        y: "123px",
        scale:3.5,
      }, {
        rotate: `357deg`,
        duration: 1.5,
        y: "0px",
        scale:1,
        ease: "power1.inOut",
      }, "1");

      tl.fromTo(".sloth", {
        scale: 0.75,
      }, {
        scale: 1,
        duration: 1.5,
        ease: "power1.inOut",
      } , "1"); 


      tl.fromTo(".heading-top", {
        scale: 0.95,
      }, {
        scale: 1,
        duration: 1.5,
        ease: "power1.inOut",
      } , "1"); 


      tl.fromTo(".heading-bottom", {
        scale: 0.9,
      }, {
        scale: 1,
        duration: 1.5,
        ease: "power1.inOut",
      } , "1"); 



      tl.fromTo(".rounded-bottom", {
        scaleY: 2,
        y: "-50%",
      }, {
        scale: 1,
        y: "0%",
        duration: 1.5,
        ease: "power1.inOut",
      } , "1"); 

      tl.fromTo(".vine", {
        scaleX: 0
      }, {
        scaleX: 1,
        duration: 0.5,
        ease: "power1.inOut",
      } , "2.2"); 


      

  }, [])

  return (
    <>
      <section
        className={`h-[500px] lg:h-[870px] relative ${inView ? `in-view` : ``}`}
        onMouseMove={mouseHandler}
        onMouseLeave={mouseLeaveHandler}
        ref={ref}
      >
          <Nav/>

        <div className="flex h-full w-full flex-row items-start justify-center absolute inset-0 hero-gradient overflow-hidden">
          <h1 className="h2 uppercase text-white text-center leading-none pt-[170px] lg:pt-[190px] z-[1] flex flex-col">
            <span className="heading-top heading inline">Slo Mo<br/></span>
            <span className="heading-bottom heading text-[56px] lg:text-[192px] inline-block">Sloth Club</span>
          </h1>
        </div>

        <div className="flex h-full w-full flex-row items-end justify-center absolute inset-0 overflow-hidden">
          <img
            src={LeftSloth}
            className="translate-x-0 sloth sloth-1 relative left-[80px] lg:left-[140px] origin-bottom-left z-[4] lg:w-[480px] w-[200px]"
          />
          <img
            src={MiddleSloth}
            className="translate-x-0 z-[5] sloth sloth-2 origin-bottom lg:w-[590px] w-[280px] mr-[-40px] lg:mr-0"
          />
          <img
            src={RightSloth}
            className="translate-x-0 sloth sloth-3 relative left-[-86px] lg:left-[-125px] origin-bottom-right z-[4] lg:w-[480px] w-[200px]"
          />
        </div>
      </section>
      <div className="mt-[-15vw] relative max-w-[100vw]">
        <div className="flex items-end">
          <div className="w-screen text-[#E6FFF1]  z-[6] relative mb-[-10px]">
            <RoundedBottom className='rounded-bottom'/>
            <Vine className="absolute top-0 vine origin-left vine max-h-[400px] w-[105%] left-[-2%]" />
            <LeftLeaf className="absolute top-[-220px] left-[-204px] w-[30vw] max-w-[500px] left-hero-leaf origin-left hidden lg:block z-[99999] scale-[3.5] translate-y-[232px] rotate-[308]" />
            <RightLeaf className="absolute top-[-12px] right-[-150px] w-[30vw] max-w-[500px] origin-right right-hero-leaf hidden lg:block z-[99999] scale-[3.5] translate-y-[123px] rotate-[397]" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
